import { Button } from "@components/shadcn/button";
import { File } from "lucide-react";
import React from "react";

interface TaskCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  lastModified?: string;
  status?: string;
}

export function TaskCard({
  icon = <File className="h-5 w-5 text-white" />,
  title,
  description,
  lastModified = "01.01.2023",
  status = "Abgeschlossen"
}: TaskCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-2 sm:p-3 md:p-4 flex flex-col h-full min-h-[200px]">
      <div className="flex-grow">
        <div className="rounded-full bg-black p-2 sm:p-2.5 w-fit mb-2 sm:mb-3 md:mb-4">
          {icon}
        </div>
        <h3 className="font-medium text-sm sm:text-base md:text-lg mb-1 line-clamp-2">{title}</h3>
        <p className="text-gray-600 text-xs sm:text-sm mb-1 sm:mb-2 line-clamp-2 sm:line-clamp-3">{description}</p>

        <div className="flex items-center gap-1 sm:gap-2 md:gap-4 mt-2 sm:mt-3 md:mt-4">
          <File className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7 text-gray-800" />
          <File className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7 text-gray-800" />
          <Button 
            variant="outline" 
            className="text-[10px] sm:text-xs md:text-sm ml-auto rounded-full px-1 sm:px-2 md:px-3 py-0.5 h-auto" 
            disabled
          >
            <span className="hidden sm:inline">Zusammenfassung anzeigen</span>
            <span className="sm:hidden">Anzeigen</span>
          </Button>
        </div>
      </div>

      <hr className="border-gray-300 my-2 sm:my-3" />

      <div className="flex justify-between items-center text-[10px] sm:text-xs mt-auto">
        <span className="text-gray-500 truncate mr-2">zuletzt: {lastModified}</span>
        <span className="font-bold whitespace-nowrap">{status}</span>
      </div>
    </div>
  );
}
